import styled from 'styled-components';

const ChatItemActionButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  height: 20px;
  border-radius: 10px;
  padding: 0 4px;
  line-height: 20px;
  font-family: var(--font-family-body);
  background-color: transparent;
  font-size: 11px;
  line-height: 18px;
  font-weight: 600;
  color: var(--content-subtitle);
  column-gap: 2px;
  border: 0;
  cursor: pointer;

  transition: background-color 0.1s linear;

  &:hover {
    background-color: var(--wash-gray-hover);
  }
`;

export { ChatItemActionButton };
